import { gql, useLazyQuery } from '@apollo/client';

export const GET_DPO_AUDIT_REPORT_HISTORY_ENTRY = gql`
  query GetDpoAuditReportHistoryEntry($id: String!) {
    getDpoAuditReportHistoryEntry(id: $id) {
      id
      createdAt
      companyId
      htmlContent
    }
  }
`;

export interface DpoAuditReportHistoryEntryFull {
  id: string;
  createdAt: string;
  companyId: string;
  htmlContent: string;
}

export interface GetDpoAuditReportHistoryEntryResult {
  getDpoAuditReportHistoryEntry: DpoAuditReportHistoryEntryFull;
}

export interface GetDpoAuditReportHistoryEntryInput {
  id: string;
}

export function useDpoAuditReportHistoryEntryQuery() {
  return useLazyQuery<GetDpoAuditReportHistoryEntryResult, GetDpoAuditReportHistoryEntryInput>(
    GET_DPO_AUDIT_REPORT_HISTORY_ENTRY
  );
}
